module.exports = __webpack_public_path__ + "f1142a54def32efdc1991a9da1d19a3a.svg";